/* piolet-reviews.js — sección de reseñas de las PDP (sections/piolet-reviews.liquid).
   Solo datos reales de Judge.me:
   - barras: el HTML del bloque de Judge.me que ya viene en la página (oculto dentro de la sección);
   - reseñas, fotos y filtros: el endpoint público que usa el propio widget (25 por página, CORS abierto).
   El HTML de Judge.me se lee con DOMParser y solo se usan textos y atributos; nunca se inyecta.
   Escritorio: mosaico (cada tarjeta a la columna más corta). Móvil (< 750): carrusel con puntos. */
(function () {
  'use strict';

  var API = 'https://api.judge.me/reviews/reviews_for_widget';
  var STAR = 'M12 2.8l2.8 5.9 6.4.8-4.7 4.4 1.2 6.4L12 17.2 6.3 20.3l1.2-6.4L2.8 9.5l6.4-.8z';
  var SRC = {
    review_collected_from_another_provider: 'src_other',
    review_collected_via_store_invite: 'src_invite',
    review_collected_from_store_visitor: 'src_visitor',
    review_written_in_google: 'src_google',
    review_written_in_shop_app: 'src_shop',
    review_earned_reward: 'src_reward'
  };
  var PAGE = 25;
  var ASPECTS = ['4 / 5', '4 / 3', '1 / 1'];
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function fmt(s, v) {
    return String(s || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, k) { return v && v[k] != null ? v[k] : ''; });
  }
  function mk(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function svg(tag, attrs) {
    var n = document.createElementNS('http://www.w3.org/2000/svg', tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    return n;
  }
  function stars(score, label) {
    var w = mk('span', 'pr__stars');
    w.setAttribute('role', 'img');
    w.setAttribute('aria-label', label);
    for (var i = 1; i <= 5; i++) {
      var s = svg('svg', { viewBox: '0 0 24 24', width: '14', height: '14', 'aria-hidden': 'true', focusable: 'false' });
      s.appendChild(svg('path', { d: STAR, fill: i <= score ? 'currentColor' : '#3A3D42' }));
      w.appendChild(s);
    }
    return w;
  }
  /* Fotos de Judge.me (review-images.judgeme.com): `width` fija el lado corto; el recorte lo hace el CSS. */
  function imgUrl(u, side) {
    try {
      var x = new URL(u, window.location.href);
      x.searchParams.set('width', String(side));
      if (/imgix\.net$/.test(x.hostname)) { x.searchParams.set('w', String(side)); x.searchParams.set('auto', 'format'); }
      return x.toString();
    } catch (e) { return u; }
  }
  function parseReviews(html) {
    var doc = new DOMParser().parseFromString('<div>' + (html || '') + '</div>', 'text/html');
    var out = [];
    doc.querySelectorAll('.jdgm-rev').forEach(function (n) {
      var q = function (s) { return n.querySelector(s); };
      var txt = function (s) { var e = q(s); return e ? e.textContent.replace(/\s+/g, ' ').trim() : ''; };
      var body = q('.jdgm-rev__body');
      var paras = body ? Array.prototype.map.call(body.querySelectorAll('p'), function (p) { return p.textContent.replace(/\s+/g, ' ').trim(); }).filter(Boolean) : [];
      if (!paras.length && body && body.textContent.trim()) paras = [body.textContent.replace(/\s+/g, ' ').trim()];
      var rating = q('.jdgm-rev__rating');
      var ts = q('.jdgm-rev__timestamp');
      var badge = q('.jdgm-rev__transparency-badge');
      var pics = Array.prototype.map.call(n.querySelectorAll('.jdgm-rev__pic-link'), function (a) {
        return a.getAttribute('data-mfp-src') || a.getAttribute('href') || '';
      }).filter(function (u) { return /^https:\/\//.test(u); });
      out.push({
        id: n.getAttribute('data-review-id') || '',
        score: parseInt(rating && rating.getAttribute('data-score'), 10) || 0,
        date: ts ? ts.getAttribute('data-content') || '' : '',
        author: txt('.jdgm-rev__author'),
        title: txt('.jdgm-rev__title'),
        paras: paras,
        pics: pics,
        variant: txt('.jdgm-rev__variant'),
        verified: n.getAttribute('data-verified-buyer') === 'true',
        src: badge ? badge.getAttribute('data-badge-type') || '' : ''
      });
    });
    return out;
  }

  function init(root) {
    if (root.__pr) return;
    root.__pr = true;
    var i18n = {};
    try { i18n = JSON.parse(root.querySelector('[data-pr-i18n]').textContent); } catch (e) {}
    var lang = (root.getAttribute('data-lang') || 'es').slice(0, 2);
    var shop = root.getAttribute('data-shop');
    var pid = root.getAttribute('data-product-id');
    var count = parseInt(root.getAttribute('data-count'), 10) || 0;
    var batch = parseInt(root.getAttribute('data-per-load'), 10) || 6;
    var native = root.querySelector('[data-pr-native]');
    var dateFmt;
    try { dateFmt = new Intl.DateTimeFormat(lang === 'en' ? 'en-US' : 'es-MX', { day: 'numeric', month: 'short', year: 'numeric' }); } catch (e) { dateFmt = null; }
    function fdate(s) {
      if (!s) return '';
      var d = new Date(s.replace(' UTC', 'Z').replace(' ', 'T'));
      if (isNaN(d)) return '';
      return dateFmt ? dateFmt.format(d).replace('.', '') : d.toISOString().slice(0, 10);
    }
    function srcLabel(r) { return r.verified ? null : (SRC[r.src] ? i18n[SRC[r.src]] : ''); }

    /* Escribir una reseña: abre el widget de Judge.me (oculto) y su formulario. */
    root.querySelectorAll('[data-pr-write]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!native) return;
        native.hidden = false;
        setTimeout(function () {
          var link = native.querySelector('.jdgm-write-rev-link');
          if (link) link.click();
          native.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        }, 60);
      });
    });
    var nclose = root.querySelector('[data-pr-native-close]');
    if (nclose) nclose.addEventListener('click', function () {
      native.hidden = true;
      var w = root.querySelector('[data-pr-write]');
      if (w) w.focus();
    });

    /* La insignia de estrellas de Judge.me y las píldoras de reseñas llevan aquí (el widget nativo está oculto). */
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('.jdgm-prev-badge, .jdgm-preview-badge, [data-pr-scroll]');
      if (!t || root.contains(t)) return;
      e.preventDefault();
      e.stopPropagation();
      root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }, true);

    if (!count) return;

    var grid = root.querySelector('[data-pr-grid]');
    var chipsEl = root.querySelector('[data-pr-chips]');
    var barsEl = root.querySelector('[data-pr-bars]');
    var statusEl = root.querySelector('[data-pr-status]');
    var moreBtn = root.querySelector('[data-pr-more]');
    var moreCount = root.querySelector('[data-pr-more-count]');
    var errEl = root.querySelector('[data-pr-error]');
    var dotsEl = root.querySelector('[data-pr-dots]');
    var photosEl = root.querySelector('[data-pr-photos]');

    /* Barras: del HTML de Judge.me que vino con la página. */
    var hist = {};
    if (native) native.querySelectorAll('.jdgm-histogram__row[data-rating]').forEach(function (r) {
      hist[r.getAttribute('data-rating')] = parseInt(r.getAttribute('data-frequency'), 10) || 0;
    });
    var seed = native ? parseReviews((native.querySelector('.jdgm-rev-widg__reviews') || {}).innerHTML || '') : [];

    var S = { filter: { type: 'all' }, list: [], page: 0, total: count, done: false, shown: 0, loading: false, cards: [], cols: -1, colEls: [], photos: { list: [], total: 0 }, lastAction: null };
    var M = { list: [], i: 0, pi: 0, total: 0, opener: null, more: null };

    function api(page, per, f) {
      var q = 'url=' + encodeURIComponent(shop) + '&shop_domain=' + encodeURIComponent(shop) + '&platform=shopify&product_id=' + encodeURIComponent(pid) + '&page=' + page + '&per_page=' + per;
      if (f && f.type === 'photos') q += '&sort_by=with_pictures';
      if (f && f.type === 'rating') q += '&filter_rating=' + f.n;
      return fetch(API + '?' + q, { credentials: 'omit' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      }).then(function (d) { return { total: parseInt(d.total_count, 10) || 0, reviews: parseReviews(d.html) }; });
    }

    function matches(r) { return S.filter.type !== 'variant' || r.variant === S.filter.v; }

    /* ---------- barras ---------- */
    function renderBars() {
      if (!barsEl) return;
      var hadBar = barsEl.contains(document.activeElement) ? document.activeElement.getAttribute('data-n') : null;
      barsEl.textContent = '';
      var have = Object.keys(hist).length > 0;
      if (!have) return;
      [5, 4, 3, 2, 1].forEach(function (n) {
        var c = hist[n] || 0;
        var b = mk('button', 'pr__bar');
        b.type = 'button';
        b.setAttribute('data-n', String(n));
        b.setAttribute('aria-label', fmt(i18n.bar_aria, { count: c, n: n }));
        if (!c) b.disabled = true;
        if (S.filter.type === 'rating' && S.filter.n === n) { b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true'); } else { b.setAttribute('aria-pressed', 'false'); }
        var lab = mk('span', 'pr__bar-n', String(n));
        var st = svg('svg', { viewBox: '0 0 24 24', width: '12', height: '12', 'aria-hidden': 'true', focusable: 'false' });
        st.appendChild(svg('path', { d: STAR, fill: 'currentColor' }));
        lab.appendChild(st);
        var tr = mk('span', 'pr__bar-track');
        var fill = mk('span', 'pr__bar-fill');
        fill.style.setProperty('--w', (count ? Math.round((c / count) * 100) : 0) + '%');
        tr.appendChild(fill);
        b.appendChild(lab); b.appendChild(tr); b.appendChild(mk('span', 'pr__bar-c', String(c)));
        b.addEventListener('click', function () {
          setFilter(S.filter.type === 'rating' && S.filter.n === n ? { type: 'all' } : { type: 'rating', n: n });
        });
        barsEl.appendChild(b);
        if (hadBar === String(n)) b.focus();
      });
    }

    /* ---------- chips ---------- */
    function variants() {
      var seen = {};
      S.list.forEach(function (r) { if (r.variant) seen[r.variant] = (seen[r.variant] || 0) + 1; });
      return Object.keys(seen).length > 1 ? seen : null;
    }
    function chip(key, label, n, active, onClick, icon) {
      var b = mk('button', 'pr__chip');
      b.type = 'button';
      b.setAttribute('data-key', key);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (icon) b.appendChild(icon);
      b.appendChild(document.createTextNode(label + ' '));
      if (n != null) b.appendChild(mk('span', 'pr__chip-n', String(n)));
      if (active && key !== 'all') {
        var x = svg('svg', { viewBox: '0 0 24 24', width: '14', height: '14', 'aria-hidden': 'true', focusable: 'false' });
        x.appendChild(svg('path', { d: 'M6 6l12 12M18 6L6 18', fill: 'none', stroke: 'currentColor', 'stroke-width': '2.4', 'stroke-linecap': 'round' }));
        b.appendChild(x);
        b.setAttribute('title', i18n.chip_clear || '');
      }
      b.addEventListener('click', onClick || function () {});
      chipsEl.appendChild(b);
    }
    function renderChips() {
      if (!chipsEl) return;
      var vsig = JSON.stringify(variants());
      var sig = JSON.stringify(S.filter) + '|' + S.photos.total + '|' + vsig;
      if (sig === S.chipSig) return;
      S.chipSig = sig;
      var had = chipsEl.contains(document.activeElement) ? document.activeElement.getAttribute('data-key') : null;
      chipsEl.textContent = '';
      var f = S.filter;
      chip('all', i18n.chip_all, count, f.type === 'all', function () { setFilter({ type: 'all' }); });
      if (S.photos.total > 0 && S.photos.total < count) {
        var cam = svg('svg', { viewBox: '0 0 24 24', width: '16', height: '16', 'aria-hidden': 'true', focusable: 'false' });
        cam.appendChild(svg('path', { d: 'M4 8h3l2-3h6l2 3h3v11H4z', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.8', 'stroke-linejoin': 'round' }));
        cam.appendChild(svg('circle', { cx: '12', cy: '13', r: '3.5', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.8' }));
        chip('photos', i18n.chip_photos, S.photos.total, f.type === 'photos', function () { setFilter(f.type === 'photos' ? { type: 'all' } : { type: 'photos' }); }, cam);
      }
      if ((hist[5] || 0) > 0 && hist[5] < count) {
        chip('r5', fmt(i18n.chip_stars, { n: 5 }), hist[5], f.type === 'rating' && f.n === 5, function () { setFilter(f.type === 'rating' && f.n === 5 ? { type: 'all' } : { type: 'rating', n: 5 }); });
      }
      if (f.type === 'rating' && f.n !== 5) {
        chip('r' + f.n, f.n === 1 ? i18n.chip_star_one : fmt(i18n.chip_stars, { n: f.n }), hist[f.n] || S.total, true, function () { setFilter({ type: 'all' }); });
      }
      var vs = variants();
      if (vs) Object.keys(vs).forEach(function (v) {
        chip('v:' + v, v, null, f.type === 'variant' && f.v === v, function () { setFilter(f.type === 'variant' && f.v === v ? { type: 'all' } : { type: 'variant', v: v }); });
      });
      if (had) { var again = chipsEl.querySelector('[data-key="' + had.replace(/"/g, '') + '"]'); if (again) again.focus(); }
    }

    /* ---------- tarjetas y mosaico ---------- */
    function card(r, idx) {
      var a = mk('article', 'pr-card');
      var who = r.author || '';
      if (r.pics.length) {
        var ib = mk('button', 'pr-card__img-btn');
        ib.type = 'button';
        ib.setAttribute('aria-label', fmt(i18n.photo_open, { name: who }));
        var im = mk('img', 'pr-card__img');
        im.loading = 'lazy';
        im.decoding = 'async';
        im.alt = fmt(i18n.photo_alt, { name: who });
        im.src = imgUrl(r.pics[0], 640);
        im.style.setProperty('--ar', ASPECTS[idx % ASPECTS.length]);
        ib.appendChild(im);
        ib.addEventListener('click', function () { openModal(visibleList(), visibleList().indexOf(r), ib, S.total, true); });
        a.appendChild(ib);
      }
      var body = mk('div', 'pr-card__body');
      var head = mk('div', 'pr-card__head');
      head.appendChild(stars(r.score, fmt(i18n.stars_aria, { rating: r.score })));
      if (r.date) { var t = mk('time', 'pr-card__date', fdate(r.date)); t.dateTime = r.date.slice(0, 10); head.appendChild(t); }
      body.appendChild(head);
      if (r.title) body.appendChild(mk('h3', 'pr-card__title', r.title));
      if (r.paras.length) body.appendChild(mk('p', 'pr-card__text', r.paras.join(' ')));
      var more = mk('button', 'pr-card__more', i18n.read_more);
      more.type = 'button';
      more.setAttribute('aria-haspopup', 'dialog');
      more.addEventListener('click', function () { openModal(visibleList(), visibleList().indexOf(r), more, S.total, true); });
      body.appendChild(more);
      var foot = mk('div', 'pr-card__foot');
      foot.appendChild(mk('span', 'pr-card__author', who));
      if (r.verified) {
        var v = mk('span', 'pr-card__ver', i18n.verified);
        foot.appendChild(v);
      } else if (srcLabel(r)) {
        foot.appendChild(mk('span', 'pr-card__src', srcLabel(r)));
      }
      body.appendChild(foot);
      a.appendChild(body);
      /* Toda la tarjeta abre la reseña (en el mosaico recortado, "Leer más" puede quedar bajo el degradado). */
      a.addEventListener('click', function (e) {
        if (e.target.closest('button, a') || (window.getSelection && String(window.getSelection()))) return;
        openModal(visibleList(), visibleList().indexOf(r), more, S.total, true);
      });
      a.addEventListener('animationend', function () { a.classList.add('is-shown'); a.style.removeProperty('--d'); }, { once: true });
      return a;
    }
    function visibleList() { return S.list.filter(matches).slice(0, S.shown); }
    function colCount() {
      if (window.innerWidth < 750) return 0;
      return grid.clientWidth >= 760 ? 3 : 2;
    }
    function layout(force) {
      var n = colCount();
      if (n === S.cols && !force) return;
      S.cols = n;
      grid.textContent = '';
      S.colEls = [];
      for (var i = 0; i < n; i++) { var c = mk('div', 'pr__col'); grid.appendChild(c); S.colEls.push(c); }
      S.cards.forEach(function (c) { place(c); });
      if (n === 0) updateDots();
    }
    function place(c) {
      if (!S.colEls.length) { grid.appendChild(c); return; }
      var best = S.colEls[0];
      S.colEls.forEach(function (col) { if (col.offsetHeight < best.offsetHeight) best = col; });
      best.appendChild(c);
    }
    function showMore() {
      var vis = S.list.filter(matches);
      var target = Math.min(vis.length, S.shown + batch);
      var k = 0;
      for (var i = S.shown; i < target; i++) {
        var c = card(vis[i], i);
        c.style.setProperty('--d', (k++ * 60) + 'ms');
        S.cards.push(c);
        place(c);
      }
      S.shown = target;
      afterRender();
    }
    function afterRender() {
      var vis = S.list.filter(matches).length;
      var left = S.done ? vis - S.shown : Math.max(S.total - S.shown, 1);
      var hasMore = S.shown < vis || !S.done;
      moreBtn.hidden = !hasMore || left <= 0;
      if (moreCount) moreCount.textContent = fmt(i18n.more_count, { shown: S.shown, total: S.filter.type === 'variant' ? vis : S.total });
      grid.classList.toggle('is-clipped', !root.classList.contains('is-expanded') && grid.scrollHeight > grid.clientHeight + 4);
      moreBtn.parentNode.hidden = moreBtn.hidden && errEl.hidden;
      if (statusEl) statusEl.textContent = fmt(i18n.showing, { count: S.filter.type === 'variant' ? vis : S.total });
      if (S.cols === 0) updateDots();
    }
    function need() { return S.list.filter(matches).length < S.shown + batch && !S.done; }
    function load() {
      if (S.loading) return Promise.resolve();
      if (!need()) { showMore(); return Promise.resolve(); }
      S.loading = true;
      errEl.hidden = true;
      var f = S.filter.type === 'variant' ? { type: 'all' } : S.filter;
      var token = S.token;
      return api(S.page + 1, PAGE, f).then(function (d) {
        if (token !== S.token) return;
        S.page += 1;
        if (S.filter.type !== 'variant') S.total = d.total;
        var ids = {};
        S.list.forEach(function (r) { ids[r.id] = 1; });
        d.reviews.forEach(function (r) { if (!ids[r.id]) S.list.push(r); });
        if (!d.reviews.length || S.list.length >= d.total) S.done = true;
        S.loading = false;
        if (need()) return load();
        showMore();
        renderChips();
      }).catch(function (e) {
        S.loading = false;
        if (token !== S.token) return;
        if (window.console) console.warn('[piolet-reviews]', e);
        if (!S.list.length && seed.length && S.filter.type === 'all') { S.list = seed.slice(); S.done = true; showMore(); }
        errEl.hidden = false;
        moreBtn.hidden = true;
        moreBtn.parentNode.hidden = false;
      }).then(function () {
        var sk = grid.querySelector('.pr__skel');
        if (S.cards.length || S.done) { if (sk) sk.remove(); grid.classList.remove('is-loading'); afterRender(); }
      });
    }
    function setFilter(f) {
      S.filter = f;
      S.token = (S.token || 0) + 1;
      S.list = []; S.page = 0; S.done = false; S.shown = 0; S.cards = []; S.loading = false;
      S.total = f.type === 'all' ? count : f.type === 'photos' ? S.photos.total : f.type === 'rating' ? (hist[f.n] || 0) : 0;
      root.classList.remove('is-expanded');
      S.cols = -1;
      layout(true);
      var sk = mk('div', 'pr__skel'); sk.setAttribute('aria-hidden', 'true'); sk.appendChild(mk('span')); sk.appendChild(mk('span')); sk.appendChild(mk('span'));
      grid.appendChild(sk);
      grid.classList.add('is-loading');
      renderChips();
      renderBars();
      if (f.type === 'variant') { S.list = []; }
      load();
      if (S.cols === 0) grid.scrollLeft = 0;
    }

    moreBtn.addEventListener('click', function () {
      root.classList.add('is-expanded');
      grid.classList.remove('is-clipped');
      if (!need()) showMore(); else load();
    });
    /* Con teclado, el foco en una tarjeta recortada abre el mosaico (si no, el navegador lo desplazaría por dentro). */
    grid.addEventListener('focusin', function (e) {
      if (S.cols < 1 || root.classList.contains('is-expanded')) return;
      var kb = false;
      try { kb = e.target.matches(':focus-visible'); } catch (x) {}
      if (grid.scrollTop > 0 || (kb && e.target.getBoundingClientRect().bottom > grid.getBoundingClientRect().bottom - 8)) {
        root.classList.add('is-expanded');
        grid.classList.remove('is-clipped');
        grid.scrollTop = 0;
      }
    });
    var retry = root.querySelector('[data-pr-retry]');
    if (retry) retry.addEventListener('click', function () { errEl.hidden = true; load(); });

    /* ---------- fotos de clientes ---------- */
    function renderPhotos() {
      if (!photosEl || !S.photos.list.length) return;
      var g = photosEl.querySelector('[data-pr-photos-grid]');
      var cnt = photosEl.querySelector('[data-pr-photos-count]');
      g.textContent = '';
      if (cnt) cnt.textContent = fmt(i18n.photos_count, { count: S.photos.total });
      var list = S.photos.list.slice(0, 8);
      list.forEach(function (r, i) {
        var last = i === 7 && S.photos.total > 8;
        var b = mk('button', 'pr__ph');
        b.type = 'button';
        b.setAttribute('aria-label', last ? i18n.photos_more : fmt(i18n.photo_open, { name: r.author }));
        var im = mk('img');
        im.alt = '';
        im.loading = 'lazy';
        im.decoding = 'async';
        im.src = imgUrl(r.pics[0], 200);
        b.appendChild(im);
        if (last) b.appendChild(mk('span', 'pr__ph-more', '+' + (S.photos.total - 7)));
        b.addEventListener('click', function () {
          if (last) { setFilter({ type: 'photos' }); grid.focus({ preventScroll: true }); return; }
          openModal(S.photos.list, i, b, S.photos.total, false);
        });
        g.appendChild(b);
      });
      photosEl.hidden = false;
    }

    /* ---------- móvil: puntos ---------- */
    function cardStep() { var c = grid.querySelector('.pr-card'); return c ? c.getBoundingClientRect().width + 12 : grid.clientWidth; }
    function curIndex() { return Math.max(0, Math.round(grid.scrollLeft / cardStep())); }
    function updateDots() {
      if (!dotsEl) return;
      var n = S.cards.length;
      dotsEl.hidden = S.cols !== 0 || n < 2;
      if (dotsEl.hidden) return;
      var cur = Math.min(curIndex(), n - 1);
      dotsEl.textContent = '';
      var row = mk('span', 'pr__dots-row');
      var start = Math.max(0, Math.min(cur - 2, n - 5));
      for (var i = start; i < Math.min(n, start + 5); i++) {
        var d = mk('button', 'pr__dot' + (i === cur ? ' is-active' : '') + ((i === start && start > 0) || (i === start + 4 && start + 5 < n) ? ' is-small' : ''));
        d.type = 'button';
        d.setAttribute('aria-label', fmt(i18n.dot, { i: i + 1 }));
        if (i === cur) d.setAttribute('aria-current', 'true');
        (function (k) { d.addEventListener('click', function () { grid.scrollTo({ left: k * cardStep(), behavior: reduce ? 'auto' : 'smooth' }); }); })(i);
        row.appendChild(d);
      }
      dotsEl.appendChild(row);
      dotsEl.appendChild(mk('span', 'pr__dots-pos', fmt(i18n.position, { i: cur + 1, total: S.filter.type === 'variant' ? S.list.filter(matches).length : S.total })));
    }
    var ticking = false;
    grid.addEventListener('scroll', function () {
      if (S.cols !== 0 || ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        updateDots();
        if (grid.scrollLeft + grid.clientWidth > grid.scrollWidth - cardStep() * 2) {
          if (S.shown < S.list.filter(matches).length) showMore(); else if (!S.done) load();
        }
      });
    }, { passive: true });

    /* ---------- reseña completa ---------- */
    var dlg = root.querySelector('[data-pr-modal]');
    if (dlg && dlg.parentNode !== document.body) document.body.appendChild(dlg);
    var m = function (s) { return dlg.querySelector(s); };
    function renderModal() {
      var r = M.list[M.i];
      if (!r) return;
      var hasPics = r.pics.length > 0;
      dlg.classList.toggle('no-media', !hasPics);
      var img = m('[data-pr-m-img]');
      var thumbs = m('[data-pr-m-thumbs]');
      thumbs.textContent = '';
      if (hasPics) {
        M.pi = Math.min(M.pi, r.pics.length - 1);
        img.src = imgUrl(r.pics[M.pi], 900);
        img.alt = fmt(i18n.photo_alt, { name: r.author });
        m('[data-pr-m-pcount]').textContent = r.pics.length > 1 ? fmt(i18n.photo_counter, { i: M.pi + 1, total: r.pics.length }) : '';
        if (r.pics.length > 1) r.pics.forEach(function (u, k) {
          var tb = mk('button', 'pr-modal__thumb');
          tb.type = 'button';
          tb.setAttribute('aria-label', fmt(i18n.photo_counter, { i: k + 1, total: r.pics.length }));
          if (k === M.pi) tb.setAttribute('aria-current', 'true');
          var ti = mk('img'); ti.alt = ''; ti.src = imgUrl(u, 120);
          tb.appendChild(ti);
          tb.addEventListener('click', function () { M.pi = k; renderModal(); });
          thumbs.appendChild(tb);
        });
      } else {
        img.removeAttribute('src');
        m('[data-pr-m-pcount]').textContent = '';
      }
      m('[data-pr-m-counter]').textContent = fmt(i18n.counter, { i: M.i + 1, total: M.total || M.list.length });
      var st = m('[data-pr-m-stars]');
      st.textContent = '';
      st.appendChild(stars(r.score, fmt(i18n.stars_aria, { rating: r.score })));
      var dt = m('[data-pr-m-date]');
      dt.textContent = fdate(r.date);
      dt.dateTime = (r.date || '').slice(0, 10);
      m('[data-pr-m-title]').textContent = r.title || r.author;
      var tx = m('[data-pr-m-text]');
      tx.textContent = '';
      r.paras.forEach(function (p) { tx.appendChild(mk('p', null, p)); });
      m('[data-pr-m-author]').textContent = r.author;
      var src = m('[data-pr-m-src]');
      src.className = r.verified ? 'pr-card__ver' : '';
      src.textContent = r.verified ? i18n.verified : (srcLabel(r) || '');
      m('[data-pr-m-prev]').disabled = M.i === 0;
      m('[data-pr-m-next]').disabled = M.i >= M.list.length - 1 && !(M.more && !S.done);
    }
    function openModal(list, i, opener, total, fromGrid) {
      if (!dlg || i < 0) return;
      M.list = list; M.i = i; M.pi = 0; M.total = total; M.opener = opener; M.more = fromGrid;
      renderModal();
      document.documentElement.classList.add('pr-modal-open');
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      var c = m('[data-pr-m-close]');
      if (c) c.focus();
    }
    function closeModal() { if (typeof dlg.close === 'function') dlg.close(); else { dlg.removeAttribute('open'); onClose(); } }
    function onClose() {
      document.documentElement.classList.remove('pr-modal-open');
      if (M.opener && document.contains(M.opener)) M.opener.focus({ preventScroll: true });
    }
    function step(d) {
      var n = M.i + d;
      if (n < 0) return;
      if (n < M.list.length) { M.i = n; M.pi = 0; renderModal(); return; }
      if (M.more && !S.done) {
        load().then(function () { M.list = visibleList(); if (n < M.list.length) { M.i = n; M.pi = 0; } renderModal(); });
      }
    }
    if (dlg) {
      dlg.addEventListener('close', onClose);
      m('[data-pr-m-close]').addEventListener('click', closeModal);
      m('[data-pr-m-prev]').addEventListener('click', function () { step(-1); });
      m('[data-pr-m-next]').addEventListener('click', function () { step(1); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) closeModal(); });
      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      });
    }

    /* ---------- arranque ---------- */
    renderBars();
    renderChips();
    S.cols = -1;
    var skel = grid.querySelector('.pr__skel');
    layout(true);
    if (skel) grid.appendChild(skel);
    grid.classList.add('is-loading');
    S.token = 1;
    load();
    api(1, 12, { type: 'photos' }).then(function (d) {
      S.photos.total = d.reviews.length ? d.total : 0;
      S.photos.list = d.reviews.filter(function (r) { return r.pics.length; });
      renderPhotos();
      renderChips();
    }).catch(function () {});

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { layout(false); afterRender(); }, 150);
    }, { passive: true });

    if (!reduce && 'IntersectionObserver' in window) {
      root.classList.add('pr--anim');
      var io = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { root.classList.add('is-in'); io.disconnect(); }
      }, { threshold: 0.2 });
      io.observe(root);
    }
  }

  function boot() { document.querySelectorAll('[data-pr-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
